import React from 'react';
import { List, ListItemText, ListItem, Divider, Slide } from '@material-ui/core';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import { useStyles } from './styles';

interface Props {
  playlist?: any;
  show: boolean;
  setShow: (value: boolean) => void;
}

export const Playlist = (props: Props) => {
  const classes = useStyles();

  return (
    <Slide in={props.show} direction="right">
      <div>
        <h2 style={{ color: 'white', textAlign: 'center' }}>
          <MusicNoteIcon fontSize="small" />
          Here's your playlist!
          <MusicNoteIcon fontSize="small" />
        </h2>
        <div className={classes.paper} style={{ height: window.screen.width > 600 ? 350 : 200, overflow: 'auto' }}>
          {props.playlist.map((song: any, index: number) => {
            return (
              <div>
                <List dense disablePadding>
                  <ListItem key={index}>
                    <ListItemText style={{ color: 'white' }}>
                      {song.name} - {song.artists[0].name}
                    </ListItemText>
                  </ListItem>
                </List>
                <Divider />
              </div>
            );
          })}
        </div>
      </div>
    </Slide>
  );
};
